export default __webpack_public_path__ + "static/media/105_jinjoke_kawai0001.84e8c203.png";